import { render } from "./CopyButton.vue?vue&type=template&id=13031280"
import script from "./CopyButton.vue?vue&type=script&lang=ts"
export * from "./CopyButton.vue?vue&type=script&lang=ts"
script.render = render

export default script